import { useQuery } from '@tanstack/react-query'

import { axios, ExtractFnReturnType, QueryConfig } from '@apps-common/lib'
import { IUnitTriggerModel } from '@apps-common/types/portal/unit-trigger'

export const QUERY_GET_UNIT_TRIGGERS = (unitId?: string) => ['getUnitTriggers', unitId].filter(Boolean)

const getUnitTriggers = async (unitId: string): Promise<IUnitTriggerModel[]> =>
  axios.get(`/unittrigger/gettriggers?unitId=${unitId}`).then((res) => res.data?.data)

type QueryFnType = typeof getUnitTriggers

type Props = {
  config?: QueryConfig<QueryFnType>
  unitId: string
}

export const useGetUnitTriggers = ({ config, unitId }: Props) =>
  useQuery<ExtractFnReturnType<QueryFnType>>({
    ...{ ...config, cacheTime: 0 },
    queryKey: QUERY_GET_UNIT_TRIGGERS(unitId),
    queryFn: () => getUnitTriggers(unitId)
  })
